import { render } from "./AiPromptPanel.vue?vue&type=template&id=45b553d7&scoped=true"
import script from "./AiPromptPanel.vue?vue&type=script&lang=js"
export * from "./AiPromptPanel.vue?vue&type=script&lang=js"

import "./AiPromptPanel.vue?vue&type=style&index=0&id=45b553d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b553d7"]])

export default __exports__